
/*eslint-disable*/
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createApp } from 'vue';
import router from './router/index';
import store from './store/store';
import App from './App';
import { createGtm } from '@gtm-support/vue-gtm';
import Format from '_shared_/plugins/format';
const $format = Format.formatHelpers;
import PolyFills from '_shared_/utils/polyfills';
import { isMarkitEnvironment } from '_shared_/utils/utils.js';
import lodash from 'lodash';
import LinksMixin from '_mixins_/LinksMixin';
import GlobalUtilitiesMixin from '_mixins_/GlobalUtilitiesMixin.vue';
import FeatureFlagMixin from '_mixins_/FeatureFlagMixin';
import GlobalErrorCatch from '_mixins_/GlobalErrorCatch';
import ConditionalRenderingMixin from '_mixins_/ConditionalRenderingMixin';
import disclosureSuperscript from '_components_/global/disclosureSuperscript';
import IBallModal from '_components_/global/IBallModal';
import UtilityLink from '_components_/global/UtilityLink.vue';
import FloatingVue from 'floating-vue';
import StickyTextWrap from '_components_/global/StickyTextWrap';
import EventBus from '_eventBus_/eventBus';
import { getFormattedEnvironmentCookie } from './shared/utils/cookieHelper';
import _ from 'lodash';
import axios from 'axios';
import featureFlagResolver from './shared/utils/featureFlagResolver';
PolyFills.loadPolyFills();

const gtmConfig = {
	id: _.get(window, `MD.GTM['GTM-ID']`, ''), // Your GTM single container ID; passed by globals-setup based on environment
	queryParams: _.get(window, 'MD.GTM.queryParams', {}), // Add url query string when load gtm.js with GTM ID (optional); passed by globals-setup based on environment
	enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
	debug: true, // Whether or not display console logs debugs (optional)
	loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
	vueRouter: router, //Pass the router instance to automatically sync with router (optional)
	ignoredViews: [''] // If router, you can exclude some routes name (case insensitive) (optional)
};

class AFISClass {
	constructor(appConfig, appContent, root) {
		this.appConfig = appConfig;
		this.appContent = appContent;
		this.$root = $(root);
		store.commit('setAppConfig', this.appConfig);
	}

	async init() {
		// Read environment variables from `globals.js`
		if (window.MD) {
			const environment = window.MD.ENV || 'production';
			const stagingFlag = getFormattedEnvironmentCookie(environment);

			try {
				const url = `${window.MD.API_URL}/util/features?stagingFlag=${stagingFlag}`;
				const response = await axios.get(url);
				featureFlagResolver.setFeatureFlags(response?.data?.data);
			} catch (error) {
				console.error('error with featureflags: ', error);
			}
			const baseUrl = environment === 'production'
				? 'https://www.capitalgroup.com'
				: 'https://www.stg.capitalgroup.com';
			store.commit('init', {
				apiBase: window.MD.API_URL,
				baseUrl,
				disclosureApiBase: window.MD.DISCLOSURE_API_URL,
				environment,
				stagingFlag
			});
		} else {
			 
			console.error('Globals.js was not set up correctly in com_markit_afis.appclass.js');
			store.commit('init', {
				apiBase: 'https://api.markitdigital.com/apiman-gateway/CapitalGroup/afis/1.0',
				baseUrl: 'https://www.capitalgroup.com',
				environment: 'production',
				stagingFlag: 'prodlive'
			});
		}
		
		try {
			const app = createApp(App);
			app.config.warnHandler = (msg, vm, trace) => {
				// Handle the warning here
				console.warn(`[Vue warn]: ${msg}\nTrace: ${trace}`);
				// You can also send the warning to an external logging service
			};
			app.use(lodash);
			app.use(router);
			app.use(store);
			app.config.globalProperties['$EventBus'] = EventBus;
			app.config.globalProperties['$format'] = $format;
			app.component('DisclosureSuperscript', disclosureSuperscript);
			app.use(FloatingVue);
			app.component('IBallModal', IBallModal);
			app.component('StickyTextWrap', StickyTextWrap);
			app.component('UtilityLink', UtilityLink);
			app.mixin(GlobalUtilitiesMixin);
			app.mixin(LinksMixin);
			app.mixin(FeatureFlagMixin);
			app.mixin(GlobalErrorCatch);
			app.mixin(ConditionalRenderingMixin);
			if (isMarkitEnvironment()) app.use(createGtm(gtmConfig));
			app.mount('.com_markit_afis');

		} catch (err) {
			console.err('Error configuring and mounting app: ', err);
		}
	}
}

/**
* @DevCenter-Group=Investments
* @DevCenter-AppId=com_markit_afis
* @DevCenter-Name=Investments App
* @DevCenter-AppContext={ "symbol": "MSFT" }
*/

F2.Apps['com_markit_afis'] = AFISClass;
